import React from 'react';
import SEO from '@/components/SEO';
import LoanTypes from '../components/LoanTypes';
import EMICalculator from '../components/EMICalculator';

const LoansPage = () => {
  return (
    <>
      <SEO
        title="Loan Products - AssetWise Business Consultants"
        description="Explore our comprehensive loan products: Home loans, education loans, car loans, business loans, and more. Competitive rates starting from 7.25% p.a."
        path="/loans"
        keywords="home loan 7.25%, car loan, education loan, gold loan, SME loan, loan against property, project finance"
      />
      
      <div className="pt-20">
        <LoanTypes />
        <EMICalculator />
      </div>
    </>
  );
};

export default LoansPage;
